<template>
  <div v-if="accessStatus == 'valid'">
    <slot />
  </div>
  <div v-else>
    <AccessDenied :access-status="accessStatus" :current-subject="subject" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import { SfUserRole, SfSubject, SfAccessStatus } from "@/types/generalTypes";
import userHasRole from "@/func/user/userHasRole";

import AccessDenied from "./AccessDenied.vue";

export default defineComponent({
  components: { AccessDenied },
  props: {
    private: { type: Boolean, default: true },
    userTypes: {
      type: Object as PropType<SfUserRole[]>,
      default: () => [] as SfUserRole[],
    },
    subject: { type: String as PropType<SfSubject | "">, default: "" },
    onlyMaths: { type: Boolean, default: false },
    adminCanAlwaysSee: { type: Boolean, default: false },
    individualCanAlwaysSee: { type: Boolean, default: false },
  },
  data() {
    return {
      accessStatus: "" as SfAccessStatus,
    };
  },
  mounted() {
    this.refreshAccess();
  },
  methods: {
    refreshAccess() {
      this.accessStatus = this.getAccess();
    },
    getAccess(): SfAccessStatus {
      const user = this.$currentUser.value;
      if (!this.private) {
        return "valid";
      }
      if (!user) {
        return "loggedout";
      }
      if (this.adminCanAlwaysSee) {
        if (userHasRole(this.$currentUser.value, ["schoolAdmin"])) {
          return "valid";
        }
        if (userHasRole(this.$currentUser.value, ["teacher", "student"])) {
          if (!this.$currentUser.value?.school?.isActive) {
            return "inactive";
          }
        }
      }
      if (this.individualCanAlwaysSee) {
        if (userHasRole(this.$currentUser.value, ["individual"])) {
          return "valid";
        }
      }
      if (this.subject == "mfGame") {
        return user.hasMfGamesAccess ? "valid" : "nosubject";
      }
      if (this.subject == "mfWs") {
        return user.hasMfWsAccess ? "valid" : "nosubject";
      }
      if (userHasRole(this.$currentUser.value, ["individual"])) {
        if (!this.$currentUser.value?.isActive) {
          return "inactive";
        }
      }
      if (this.userTypes.length < 1 || userHasRole(user, this.userTypes)) {
        if (this.subject == "maths") {
          return user.hasMathsAccess ? "valid" : "nosubject";
        } else if (this.subject == "spelling") {
          return user.hasSpellingAccess ? "valid" : "nosubject";
        } else {
          if (
            userHasRole(this.$currentUser.value, ["mfIndividual", "mfSchool"])
          ) {
            return "valid";
          }
          return user.hasMathsAccess ||
            user.hasSpellingAccess ||
            user.hasMfGamesAccess ||
            user.hasMfWsAccess
            ? "valid"
            : "nosubject";
        }
      }
      return "unknownError";
    },
  },
  watch: {
    "$currentUser.value"() {
      this.refreshAccess();
    },
  },
});
</script>
